import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32844e6c")

_pushScopeId("data-v-32844e6c")
const _hoisted_1 = { class: "all" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "message" }, "选择索赔订单", -1)
const _hoisted_3 = { class: "bottom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_claim_table = _resolveComponent("claim-table")
  const _component_claim_dialog = _resolveComponent("claim-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_divider),
    _createVNode(_component_claim_table),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_claim_dialog)
    ])
  ]))
})